import { useCallback, useEffect, useState } from "react";
import { api } from "./api";
import type { GraphPayload, Manifest, SnapshotEvent } from "./types";

export function useLiveSnapshot() {
  const [manifest, setManifest] = useState<Manifest>();
  const [graph, setGraph] = useState<GraphPayload>();
  const [lastEvent, setLastEvent] = useState<SnapshotEvent>();
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState<string>();

  const refresh = useCallback(async (version?: number) => {
    try {
      const nextManifest = await api.manifest();
      const nextGraph = await api.graph(version ?? nextManifest.version);
      setManifest(nextManifest);
      setGraph(nextGraph);
      setError(undefined);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Не удалось загрузить граф");
    }
  }, []);

  useEffect(() => void refresh(), [refresh]);

  useEffect(() => {
    const source = new EventSource("/api/events");
    source.onopen = () => setConnected(true);
    source.onerror = () => setConnected(false);
    source.addEventListener("snapshot", (raw) => {
      const event = JSON.parse((raw as MessageEvent<string>).data) as SnapshotEvent;
      setLastEvent(event);
      if (event.graphChanged) void refresh(event.version);
      else setManifest((current) => current ? { ...current, version: event.version } : current);
    });
    source.addEventListener("resync", (raw) => {
      const data = JSON.parse((raw as MessageEvent<string>).data) as { version: number };
      void refresh(data.version);
    });
    return () => source.close();
  }, [refresh]);

  return { manifest, graph, lastEvent, connected, error, refresh };
}
